import { Helmet } from 'react-helmet';
import {
    Box, Button,
    Container,
    Grid, Typography,
    usePagination,
    MenuItem,
    Select,
    TextField,
    InputAdornment,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import newsService from "../../../services/news.service";
import iconNews from "../../../assets/images/news/icon-new.svg";
import noDataNews from "../../../assets/images/news/img_no_data.svg";
import cssVariables from "../../../theme/cssVariables";
import Search from "@mui/icons-material/Search";

import defaultBanner from "../../../assets/images/announcement/default.jpg"

import * as Util from "../../../services/global.service";

const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "background-color": "#fff",
        height: "220px",
        "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)",
        "border-radius": "10px",
        "justify-content": "center",
        "align-items": "center",
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    }
};

const useStyles = makeStyles({
    swiperStyles: {
        paddingTop: "10px !important"

    },
    iconContainer: {
        '& svg': {
            width: "45px",
            height: "45px"
        }
    },
    statusBadge: {
        maxWidth: "150px",
        borderRadius: "5px",
        padding: "5px 12px",
        margin: "0",
    },
    processBgGoals: {
        background: "#4085C9  !important",
        color: "#4085C9 !important",
        "&:hover": {
            backgroundColor: "#4085C9 !important",
        },
        "& > .MuiButton-root": {
            color: "none",
        }
    },

    processBgRubric: {
        background: "#85AEB0 !important",
        "&:hover": {
            backgroundColor: "#85AEB0 !important",
        },
    },

    processBgCompetency: {
        background: "#958CCB !important",
        "&:hover": {
            backgroundColor: "#958CCB !important",
        },
    },

    styleTextBtSmall: {
        color: "##949494 !important",
        fontWeight: "600",
        fontSize: "12px",
        lineHeight: "15px",
    },

    styleTextBtBig: {
        color: "##949494 !important",
        fontWeight: "600",
        fontSize: "18px",
        lineHeight: "29px",
    },
    searchSvg: {
        "& > path": {
            fill: "#C4C4C4",
        },
    },
})

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        }

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}



const AllNews = () => {

    const { t } = useTranslation();

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }

    const [filteredList, setFilteredList] = React.useState([]);
    const [groupedReq, setGroupReq] = React.useState([]);
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };

    // handle search
    const [search, setSearchValue] = React.useState("");
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    const [dataAllsNews, setDataAllNews] = React.useState([]);
    const [dataOldNews, setOldNewsList] = React.useState([]);
    const [dataFilterNews, setDataFilterNews] = React.useState([]);

    const getAllNewsData = () => {
        newsService.news().then(
            (response) => {
                if (response.data !== undefined && response.data !== null && response.data !== "null") {
                    setDataAllNews(response.data)
                }


            },
        );
    }

    useEffect(() => {
        setDataFilterNews(dataAllsNews)
    }, [dataAllsNews]);

    const setOldNews = (data) => {
        let result = [];

        for (let index = 0; index <= data.length - 1; index++) {

            if (index > 4) {
                result.push(data[index])
            }

        }
        setOldNewsList(result);

    }


    useEffect(() => {
        dataSerach()
    }, [search]);

    const dataSerach = () => {
        let result = []

        let dataSerach = JSON.parse(JSON.stringify(dataAllsNews))

        if (search !== "" && dataSerach !== undefined) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some((key) => {
                    if (key === 'title' || key === 'description' || key === 'excerpt' || key === 'client') {
                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        setDataFilterNews(result);
        setOldNews(result)
    }

    const handleGoToDetail = (e) => {
        navigate(`/kpi/announcement/contentnews/${e}`, { replace: false });
    }

    const [dataTags, setListTag] = React.useState([]);

    let getTagsHome = (tags) => {
        newsService.tags(tags).then(
            (response) => {
                navigate(`/kpi/announcement/typenews/${tags}`, { replace: false })
            },
        );
    }

    let getTagsList = () => {
        newsService.tagsList().then(
            (response) => {
                setListTag(response.data)
            },
        );
    }

    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };
    const handleTotalPage = () => {
        const List = filteredList
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    // update qty for each status when list changed
    useEffect(() => {
        handleTotalPage();
    }, [filteredList, perPage]);

    useEffect(() => {
        setOldNews(dataAllsNews);

    }, [dataAllsNews]);

    useEffect(() => {
        getAllNewsData();
        getTagsList();
    }, []);

    useEffect(() => {
        setFilteredList(dataOldNews);
    }, [dataOldNews]);

    const [valueTab, setValueTab] = React.useState("all");

    useEffect(() => {
        handleTotalPage();
    }, [valueTab]);
    const currentTableData = useMemo(() => {
        handleTotalPage();
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return filteredList
            .slice(firstPageIndex, lastPageIndex);
    }, [filteredList, currentPage, perPage]);


    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }


    return (
        <>
            <Helmet>
                <title>Announcment | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3,
                    width: '100%'
                }}
            >
                <Container maxWidth="xl">

                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("news.label.homePage")}</span> / <span style={styles.end} >{t("news.label.news")}</span></Typography>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs sm md lg>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }} >

                                <Box sx={{ width: "100%" }}>
                                    <Typography fontSize={36} color="#404349" lineHeight="39.6px" paddingBottom="14px" fontWeight="600px">
                                        {t("news.label.news")}
                                    </Typography>
                                    <Box sx={{ display: "flex", alignItems: "Center", justifyContent: "space-between" }}>

                                        {/* <Box sx={{
                                            display: "flex", flexDirection: "row", alignItems: "Center", cursor: 'pointer', "&:hover": {
                                                textDecoration: "underline"
                                            },
                                        }} onClick={() => clickLink('/kpi/home')} >
                                            <img src={iconArrow} style={{ maxWidth: '22px', maxHeight: '13px' }}>

                                            </img>

                                            <Typography fontSize={18} lineHeight="19.8px" fontWeight="400px" sx={{ paddingLeft: '8px' }}>
                                                ย้อนกลับ
                                            </Typography>
                                        </Box> */}

                                        <Typography fontSize={18} lineHeight="19.8px" fontWeight="400px" color="#404349">
                                            {t("news.label.newTags")}
                                        </Typography>

                                        <Grid item sm={12} xs={12} md={4} ml="auto" >
                                            <TextField
                                                id="input-with-icon-textfield"
                                                fullWidth
                                                placeholder={t("news.label.search")}
                                                size="small"
                                                sx={{ background: "#fff" }}
                                                className="searchTextField-h48"
                                                value={search}
                                                onChange={handleSearch}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Search className={classes.searchSvg} />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Box>


                                    <Box sx={{ display: "flex", paddingTop: "10px" }}>

                                        {dataTags.map(itemname => (
                                            <Button onClick={() => getTagsHome(itemname)} sx={{ "border-radius": '22px', '&:last-child': { marginRight: '0px' }, marginRight: '15px', padding: "5px 20px" }}
                                                className={classes.processBgGoals}>
                                                <Typography fontSize={16} lineHeight="14px" color="#FFFFFF" >
                                                    {itemname}
                                                </Typography>
                                            </Button>
                                        )
                                        )

                                        }

                                    </Box>
                                </Box>

                            </Box>

                            {
                                dataFilterNews.length > 0 ?
                                    <>

                                        <Box sx={{ background: '#FFFFFF', "box-shadow": '0px 0px 10px rgba(0, 0, 0, 0.1)', "border-radius": '10px', margin: '20px', marginRight: "0px" }}>
                                            <Grid sx={{ padding: '20px', display: "flex" }} xs md lg={12}>
                                                <Grid sx={{ borderRadius: '5px', height: '100%', width: '100%', }} xs md lg={8} mr={2}>
                                                    <img src={dataFilterNews[0].thumbnail ? dataFilterNews[0].thumbnail : defaultBanner} style={{ maxWidth: '100%', maxHeight: '100%', height: '100%', width: '100%', borderRadius: '5px' }} alt="banner" />
                                                </Grid>
                                                <Grid xs md lg={4} sx={{ position: "relative" }}>
                                                    <Typography fontSize={36} lineHeight="58.32px" color="#404349" fontWeight={700} sx={{ cursor: 'pointer' }} onClick={() => handleGoToDetail(dataFilterNews[0].serial)}>
                                                        {formatData(dataFilterNews[0].title, "-")}
                                                    </Typography>

                                                    <Typography fontSize={24} lineHeight="36px" color="#838383" fontWeight={300} sx={{ paddingTop: "10px" }}>
                                                        {formatData(dataFilterNews[0].excerpt, "-")}
                                                    </Typography>

                                                    {/* <Box sx={{ display: "flex", paddingop: "10px", flexFlow: "row wrap" }}>
                                                        {
                                                            dataFilterNews[0].tags.map(itemname => (
                                                                <Button sx={{ "border-radius": '22px', '&:last-child': { marginRight: '0px' }, marginRight: '10px', marginTop: '5px', padding: "5px 10px" }}
                                                                    className={classes.processBgGoals}>
                                                                    <Typography fontSize={12} lineHeight="14px" color="#FFFFFF" >
                                                                        {itemname}
                                                                    </Typography>
                                                                </Button>
                                                            )
                                                            )
                                                        }
                                                    </Box> */}

                                                    <Typography fontSize={18} lineHeight="28px" fontWeight={400} color="#949494" sx={{ bottom: "0", position: "absolute" }}>
                                                        <span className={classes.styleTextBtBig}> {formatData(dataFilterNews[0].client, "-")}</span>    {formatData(Util.dateDayFormat(dataFilterNews[0].start_at, "-"), "-")}
                                                    </Typography>

                                                </Grid>

                                            </Grid>

                                        </Box>
                                        <Box sx={{ display: "flex", width: '100%' }}>
                                            {dataFilterNews.length > 0 ?

                                                dataFilterNews.map((item, index) => (

                                                    index > 0 && index < 5 ?

                                                        <Box sx={{ background: '#FFFFFF', "box-shadow": '0px 0px 10px rgba(0, 0, 0, 0.1)', "border-radius": '10px', margin: '18px 10px', width: '25%', '&:first-child': { marginLeft: '20px' }, '&:last-child': { marginRight: '0px' } }}>
                                                            <Box sx={{ padding: '20px 10px' }}>
                                                                <Box sx={{ borderRadius: '5px', height: '12.43vw', width: '100%', maxHeight: "179px" }}>
                                                                    <img src={item.thumbnail} style={{ height: '100%', width: '100%', borderRadius: '5px' }}>

                                                                    </img>
                                                                </Box>
                                                                <Typography fontSize={20} lineHeight="30px" color="#404349" fontWeight={400} sx={{ wordBreak: "break-word", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: "2", WebkitBoxOrient: "vertical", paddingTop: "10px", cursor: 'pointer' }} onClick={() => handleGoToDetail(item.serial)}>
                                                                    {formatData(item.title, "-")}
                                                                </Typography>

                                                                {/* <Box sx={{ display: "flex", paddingTop: "10px", flexFlow: "row wrap" }}>
                                                                    {
                                                                        item.tags.map(itemname => (
                                                                            <Button sx={{ "border-radius": '22px', '&:last-child': { marginRight: '0px' }, marginRight: '10px', marginTop: '5px', padding: "5px 10px" }}
                                                                                className={classes.processBgGoals}>
                                                                                <Typography fontSize={12} lineHeight="14px" color="#FFFFFF" >
                                                                                    {itemname}
                                                                                </Typography>
                                                                            </Button>
                                                                        )
                                                                        )
                                                                    }
                                                                </Box> */}

                                                                <Typography fontSize={12} lineHeight="14px" fontWeight={400} color="#949494" sx={{ paddingTop: '10px' }}>
                                                                    <span className={classes.styleTextBtSmall}>{formatData(item?.client, "-")}</span>  {Util.dateDayFormat(item?.start_at, "-")}
                                                                </Typography>
                                                            </Box>

                                                        </Box>

                                                        :

                                                        null

                                                )

                                                )

                                                : null}

                                        </Box>


                                        {dataOldNews.length > 0 ?
                                            <>
                                                <Typography fontSize={36} lineHeight="39.6px" color="#404349" fontWeight="600px" paddingTop="20px">
                                                    {t("news.label.allNew")}
                                                </Typography>

                                                <Box sx={{ padding: '20px', paddingRight: "0px" }}>
                                                    <Grid container sx={{ background: '#FFFFFF', "box-shadow": '0px 0px 10px rgba(0, 0, 0, 0.1)', "border-radius": '10px', width: '100%' }}>

                                                        <Grid item>

                                                            {currentTableData.length > 0 ?
                                                                currentTableData.map(item => {
                                                                    return (

                                                                        <Grid display="flex" sx={{ padding: '20px 20px 0px 20px' }}>

                                                                            <img src={iconNews} style={{ maxWidth: '75px', maxHeight: '75px', height: '100%', width: '100%' }}>

                                                                            </img>

                                                                            <Box display="flex" flexDirection="column">

                                                                                <Typography fontSize={20} lineHeight="30px" fontWeight={600} color="#404349" sx={{ paddingTop: '10px', paddingLeft: '15px', cursor: 'pointer' }} onClick={() => handleGoToDetail(item.serial)}>

                                                                                    {formatData(item?.title, "-")}

                                                                                </Typography>

                                                                                <Box display="flex" flexDirection="row" sx={{ paddingTop: '7px', paddingLeft: '15px' }}>

                                                                                    <Typography fontSize={12} lineHeight="15px" fontWeight={600} color="#949494" >

                                                                                        {formatData(item?.client, "-")}

                                                                                    </Typography>

                                                                                    <Typography fontSize={12} lineHeight="14px" fontWeight={400} color="#949494" sx={{ paddingLeft: '10px' }}>

                                                                                        {Util.dateDayFormat(item?.start_at, "-")}

                                                                                    </Typography>

                                                                                    {/* {
                                                                                item?.tags.map(itemname => (
                                                                                    <Button sx={{ "border-radius": '22px', padding: "5px 20px", marginLeft: '15px' }}
                                                                                        className={

                                                                                            classes.processBgGoals


                                                                                        }>
                                                                                        <Typography fontSize={12} lineHeight="14px" color="#FFFFFF" >
                                                                                            {itemname}
                                                                                        </Typography>
                                                                                    </Button>
                                                                                )
                                                                                )
                                                                            } */}

                                                                                </Box>

                                                                            </Box>

                                                                        </Grid>

                                                                    )
                                                                }
                                                                )
                                                                : null
                                                            }

                                                        </Grid>

                                                        {dataOldNews?.length > 0 ?
                                                            <Grid container mt={1} spacing={2} sx={{ padding: '0px 15px 15px 15px' }} >
                                                                <Grid item xs sm md display="flex" alignItems="center">
                                                                    <Box mr={1}>
                                                                        <Typography variant="s14_fw400" >{t("label.showMaxItems")}</Typography>
                                                                    </Box>
                                                                    <Select
                                                                        id="pagination"
                                                                        variant="outlined"
                                                                        defaultValue={10}
                                                                        value={perPage}
                                                                        onChange={handlePerPageChange}
                                                                        displayEmpty
                                                                        size="small"
                                                                        className="white-bg"
                                                                    >
                                                                        <MenuItem value={10}>
                                                                            <Typography style={{ fontWeight: "300" }}>10</Typography>
                                                                        </MenuItem>
                                                                        <MenuItem value={30}>
                                                                            <Typography style={{ fontWeight: "300" }}>30</Typography>
                                                                        </MenuItem>
                                                                        <MenuItem value={50}>
                                                                            <Typography style={{ fontWeight: "300" }}>50</Typography>
                                                                        </MenuItem>
                                                                    </Select>
                                                                </Grid>
                                                                <Grid item display="flex" alignItems="center" ml="auto">
                                                                    <Typography variant="s14_fw400">
                                                                        {t('label.page')} {currentPage}  {t('label.of')} {totalPage}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item ml="auto" display="flex" alignItems="center">
                                                                    <CustomPagination
                                                                        setCurrentPage={handleSetCurrentPage}
                                                                        selected={currentPage}
                                                                        count={totalPage}
                                                                    ></CustomPagination>
                                                                </Grid>
                                                            </Grid>
                                                            : null}


                                                    </Grid>
                                                </Box>
                                            </>
                                            : null
                                        }
                                    </>
                                    :
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '300px' }}>
                                        <Grid display='flex' justifyContent='center' flexDirection='column' alignItems='center' >
                                            <img src={noDataNews} style={{ maxWidth: '120px', maxHeight: '110px', height: '100%', width: '100%' }}>

                                            </img>
                                            <Typography fontSize={16} lineHeight="24px" fontWeight={400} color="#949494" sx={{ paddingTop: '20px', 'padding-bottom': '100px' }}>
                                                {t("news.label.noNews")}
                                            </Typography>
                                        </Grid>
                                    </Box>
                            }


                        </Grid>
                    </Grid>

                </Container>
            </Box>
        </>
    )
};
export default AllNews;


